import React from 'react';
import { List, Datagrid, TextField, EditButton, DeleteButton, FunctionField, useRecordContext } from 'react-admin';
import moment from 'moment';
import PreSignedUrlField from '../../../../commonComponents/PreSignedUrlField';

const isRecordEditable = (record) => {
  if (!record || !record.date) return false;
  return moment(record.date).isSameOrAfter(moment(), 'day');
};

const JigsawEventsList = (props) => (
  <List title="Jigsaw Events" bulkActionButtons={false} sort={{ field: 'id', order: 'DESC' }} {...props}>
    <Datagrid rowClick="edit">
      <TextField label="ID" source="id" />
      <TextField label="Date" source="date" sortable={false} />
      <FunctionField label="Difficulty" render={(record) => String(record?.difficulty || '').toUpperCase()} />
      <PreSignedUrlField label="Image" source="image_file_key" />
      <ConditionalEditButton />
      <ConditionalDeleteButton />
    </Datagrid>
  </List>
);

const ConditionalEditButton = (props) => {
  const record = useRecordContext();
  return <EditButton disabled={!record || moment(record.date).isBefore(moment(), 'day')} {...props} />;
};

const ConditionalDeleteButton = (props) => {
  const record = useRecordContext();
  return <DeleteButton disabled={!isRecordEditable(record)} undoable={false} {...props} />;
};

export default JigsawEventsList;
